export default "__VITE_ASSET__DQd2llPy__"